import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-4 gap-8 mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/ce7e038c-0861-4277-bb69-958f0a8f80a8.png" 
              alt="Riverdale Hair Studio" 
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Otley's premier hair & beauty salon
            </p>
            <p className="text-gray-400 text-sm mt-2">Est. 2018</p>
            <p className="text-gray-400 text-sm">Award-winning service</p>
          </div>

          <div>
            <h4 className="text-xs uppercase text-gray-400 mb-4 tracking-wider">Stay Updated</h4>
            <form className="relative">
              <input
                type="email"
                placeholder="Your email"
                className="w-full bg-transparent border-b border-gray-600 pb-2 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-sage"
              />
              <button type="submit" className="absolute right-0 bottom-2 cursor-pointer">
                <i className="ri-arrow-right-line text-sage"></i>
              </button>
            </form>
            <p className="text-xs text-gray-500 mt-3">
              Join our mailing list for <span className="text-sage cursor-pointer hover:underline">offers</span>
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase text-gray-400 mb-4 tracking-wider">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-white hover:text-sage transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:text-sage transition-colors cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-sage transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase text-gray-400 mb-4 tracking-wider">Follow Us</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="text-white hover:text-sage transition-colors cursor-pointer">
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="text-white hover:text-sage transition-colors cursor-pointer">
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://google.com" target="_blank" rel="nofollow noopener noreferrer" className="text-white hover:text-sage transition-colors cursor-pointer">
                  Google
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-400">
              © 2025 Riverdale Hair Studio. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm text-gray-400 hover:text-sage transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>

      <div className="bg-charcoal-light py-12 overflow-hidden">
        <h2 className="text-[120px] font-bold text-cream tracking-tight text-center font-serif">
          RIVERDALE
        </h2>
      </div>
    </footer>
  );
};

export default Footer;